<template>
    <div>
        <vx-card>
            <div class="flex h-12 mt-1 fit-height">
                <div class="w-full ml-2 fit-height">
                    <form v-on:submit.prevent="salvar" id="formulario">
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-list>
                                    <draggable :list="banners">
                                        <transition-group>
                                            <vs-list-item
                                                class="list-item"
                                                v-for="(item, index) in banners"
                                                :key="'foto' + index"
                                                :title="
                                                    item.tipo == 'd'
                                                        ? 'Banner desktop'
                                                        : 'Banner mobile'
                                                "
                                            >
                                                <vs-avatar
                                                    slot="avatar"
                                                    :src="item.path"
                                                />
                                                <vs-button
                                                    radius
                                                    color="warning"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    icon="icon-edit"
                                                    v-on:click="editar(index)"
                                                    :key="
                                                        'foto' +
                                                            index +
                                                            'editar'
                                                    "
                                                ></vs-button>
                                                <vs-button
                                                    radius
                                                    color="danger"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    icon="icon-x-square"
                                                    v-on:click="remover(index)"
                                                    :key="
                                                        'foto' +
                                                            index +
                                                            'remover'
                                                    "
                                                ></vs-button>
                                            </vs-list-item>
                                        </transition-group>
                                    </draggable>

                                    <div
                                        v-if="editandoBanner"
                                        class="h-12 mt-1 fit-height"
                                    >
                                        <div class="vx-row mb-2">
                                            <div class="w-1/4"></div>
                                            <div class="w-1/4">
                                                <label
                                                    for=""
                                                    class="vs-input--label"
                                                    >Banner mobile?</label
                                                >
                                                <vs-switch
                                                    v-model="
                                                        bannerEntrada.tipo_fake
                                                    "
                                                />
                                            </div>
                                            <div class="w-1/4">
                                                <label
                                                    for=""
                                                    class="vs-input--label"
                                                    >Banner ativo?</label
                                                >
                                                <vs-switch
                                                    v-model="
                                                        bannerEntrada.banner_ativo
                                                    "
                                                />
                                            </div>
                                        </div>

                                        <div class="vx-row mb-2">
                                            <div class="w-1/3 ml-2">
                                                <vs-button
                                                    color="danger"
                                                    icon-pack="feather"
                                                    icon="icon-x-square"
                                                    style="float: left;"
                                                    class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                                    v-on:click="pararAdicao()"
                                                ></vs-button>
                                                <vs-button
                                                    color="success"
                                                    icon-pack="feather"
                                                    icon="icon-check-square"
                                                    style="float: left;"
                                                    class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                                    v-on:click="
                                                        confirmarEdicao()
                                                    "
                                                ></vs-button>
                                            </div>
                                        </div>
                                    </div>
                                </vs-list>

                                <vs-upload
                                    automatic
                                    multiple
                                    text="Enviar fotos"
                                    :action="
                                        this.$API_URL +
                                            '/upload/banner-oportunidades'
                                    "
                                    @on-success="successUpload"
                                    accept="image/*"
                                    fileName="fotos"
                                    :single-upload="true"
                                />
                            </div>
                        </div>

                        <vs-row
                            vs-type="flex"
                            vs-justify="center"
                            style="width: 100%"
                        >
                            <div style="text-align: center;">
                                <vs-button
                                    size="large"
                                    class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled"
                                    v-on:click="salvar"
                                    >Salvar</vs-button
                                >
                            </div>
                        </vs-row>
                    </form>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    components: {
        draggable
    },
    data() {
        return {
            editandoBanner: false,
            bannerEntrada: {
                link: "",
                path: "",
                tipo: "",
                tipo_fake: false,
                index: 0,
                md5: "",
                titulo: "",
                descricao: "",
                badge: "",
                destaque_home: 0,
                categoria_destaque: 0,
                banner_ativo: false
            },
            banners: []
        };
    },
    methods: {
        textAreaAdjust: function(o) {
            o.target.style.height =
                o.target.scrollHeight > o.target.clientHeight
                    ? o.target.scrollHeight + "px"
                    : "53.29px";
        },
        pararAdicao: function() {
            this.editandoBanner = false;

            this.bannerEntrada = {
                link: "",
                path: "",
                tipo: "",
                tipo_fake: false,
                index: 0,
                md5: "",
                titulo: "",
                descricao: "",
                badge: "",
                destaque_home: 0,
                categoria_destaque: 0,
                banner_ativo: false
            };
        },
        editar: function(index) {
            this.bannerEntrada.link = this.banners[index].link;
            this.bannerEntrada.path = this.banners[index].path;
            this.bannerEntrada.tipo = this.banners[index].tipo;
            this.bannerEntrada.titulo = this.banners[index].titulo;
            this.bannerEntrada.descricao = this.banners[index].descricao;
            this.bannerEntrada.badge = this.banners[index].badge;
            this.bannerEntrada.destaque_home = this.banners[
                index
            ].destaque_home;
            this.bannerEntrada.categoria_destaque = this.banners[
                index
            ].categoria_destaque;
            this.bannerEntrada.banner_ativo = this.banners[index].banner_ativo;

            if (this.bannerEntrada.tipo == "m")
                this.bannerEntrada.tipo_fake = true;

            this.bannerEntrada.md5 = this.banners[index].md5;
            this.bannerEntrada.index = index;
            this.editandoBanner = true;
            this.$nextTick(() => document.getElementById("linkBanner").focus());
        },
        successUpload(e) {
            let resposta = JSON.parse(e.target.response).data;
            this.bannerEntrada.path = resposta.path;
            this.bannerEntrada.md5 = resposta.md5;
            this.bannerEntrada.tipo = "d";
            this.bannerEntrada.tipo_fake = false;

            let existe = false;

            if (this.banners && this.banners.length > 0) {
                this.banners.forEach(foto => {
                    if (foto.md5 == resposta.md5) existe = true;
                });
            }

            if (!existe) this.banners.push(this.bannerEntrada);

            this.bannerEntrada = {
                link: "",
                path: "",
                tipo: "",
                tipo_fake: false,
                index: 0,
                md5: "",
                titulo: "",
                descricao: "",
                badge: "",
                destaque_home: 0,
                categoria_destaque: 0,
                banner_ativo: false
            };
        },
        remover: function(index) {
            this.banners.splice(index, 1);
        },
        confirmarEdicao: function() {
            if (this.bannerEntrada.tipo_fake) this.bannerEntrada.tipo = "m";
            else this.bannerEntrada.tipo = "d";

            this.banners[this.bannerEntrada.index] = this.bannerEntrada;
            this.pararAdicao();
        },
        salvar: function() {
            let url = this.$API_URL + "/banner-oportunidades";

            let banners = {
                banners: this.banners
            };

            fetch(url, {
                method: "POST",
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token")
                }),
                body: JSON.stringify(banners)
            })
                .then(response => response.json())
                .then(json => {
                    if (json.status == "success") {
                        this.$vs.notify({
                            title: "Sucesso!",
                            text: "Salvo com sucesso.",
                            color: "primary"
                        });
                    } else {
                        this.$vs.notify({
                            title: "Erro!",
                            text: "Ocorreu um erro ao salvar.",
                            color: "danger"
                        });
                    }
                });
        },
        getDados: function() {
            fetch(this.$API_URL + "/banner-oportunidades/dados", {
                method: "GET",
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token")
                })
            })
                .then(response => response.json())
                .then(json => {
                    if (
                        json.data &&
                        json.data[0] &&
                        json.data[0].banner.length > 0
                    )
                        this.banners = json.data[0].banner;
                });
        }
    },
    mounted() {
        this.getDados();
    }
};
</script>

<style>
.fit-height {
    height: fit-content !important;
}

.img-upload {
    display: none !important;
}

.vs-divider {
    margin-top: 65px !important;
    font-weight: bold !important;
}

#formulario > div:nth-child(1) {
    margin-top: unset !important;
}

.vs-button-success.vs-button-flat {
    margin-top: 30px !important;
}

.con-vs-avatar {
    height: 108px !important;
    width: 108px !important;
}

.vs-con-input-label {
    width: 80%;
}
</style>
